import styled from 'styled-components';

import BamOnlineLink from 'components/b2c/BamOnlineLink';
import { getSpacing, fontSize } from 'stylesheetB2c';

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const StyledMessagesContainer = styled.div`
  margin-bottom: ${getSpacing(6)};
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const SeeOffersLink = styled(BamOnlineLink)`
  font-size: ${fontSize.small};
  width: ${getSpacing(34)};
  height: ${getSpacing(6)};
`;
SeeOffersLink.displayName = 'SeeOffersLink';
